import * as React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import IntlMessage from '../../util/IntlMessage';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {MenuSingleRenderShape} from './menuTypes';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/styles';
import {Tooltip, Typography} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import {DOCUMENT_FORM_NAME} from "../../constants";
import * as _ from "lodash";

const styles: Record<string, Record<string, any>> = {
    navLink: {
        display: 'flex !important',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    active: {
        fontWeight: '500',
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
    },
    content: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    }
};

interface MenuItemProps extends MenuSingleRenderShape, RouteComponentProps {
    classes?: Record<string, string>;
    documentTypeId?: string;
}

const SingleNavLink: React.FunctionComponent<MenuItemProps> =
    ({title, description, icon: MenuIcon, url, documentTypeId, location, translateTitle = true, classes, onClick}: MenuItemProps) => {
        const fakeLocation = _.clone(location);

        if (/^\/documents\/[0-9]+/.test(location.pathname) && documentTypeId) {
            fakeLocation.pathname = `/documents/${documentTypeId}`;
        }

        return (
            <ListItem button component="li">
                <NavLink
                    activeClassName={classes?.active}
                    className={classes?.navLink}
                    to={url}
                    location={fakeLocation}
                    replace
                    onClick={onClick}
                >
                    <ListItemIcon className="menu-icon">
                        {MenuIcon ? <MenuIcon/> : <React.Fragment/>}
                    </ListItemIcon>
                    <div className={classes?.content}>
                        <span className="menu text-capitalize">
                            {translateTitle ? <IntlMessage id={title}/> : title}
                        </span>
                        {
                            description ? (
                                <Tooltip
                                    title={<Typography>{description}</Typography>}
                                    key={title}
                                    placement={'right'}
                                    classes={{popper: 'top-user-tour-tooltip'}}
                                >
                                    <InfoIcon/>
                                </Tooltip>
                            ) : null
                        }
                    </div>
                </NavLink>
            </ListItem>
        );
    };

const mapStateToProps = (_state: object, props: MenuItemProps) => {
    let {url, location} = props;
    if (props.url && typeof props.url === 'string' && !props.url.startsWith('/')) {  // Stupid protection
        url = `/${url}`;
    }

    const found = location.pathname.match(/^\/documents\/([0-9]+)/i);
    const documentId = found && found.length === 2 ? found[1] : null;
    const documentTypeId = _.get(_state, `form.${DOCUMENT_FORM_NAME}-${documentId}.values.documentTypeId`);

    return {url, documentTypeId};
};

// @ts-ignore
const EnhancedSingleNavLink: React.FunctionComponent<MenuSingleRenderShape> = compose(
    withRouter,
    connect(mapStateToProps, {}),
    withStyles(styles),
)(SingleNavLink);

export default EnhancedSingleNavLink;